import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { TypeMessageEnum } from '../../enums/notification-type.enum';
import { NotificationComponent } from '../notification.component';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor(private snackBar: MatSnackBar) {
    }

    snackBarRef: MatSnackBarRef<any> | undefined;

    success(msg: string, title?: string) {
        this.addSingle(TypeMessageEnum.SUCCESS, msg, title);
    }

    warn(msg: string, title?: string) {
        this.addSingle(TypeMessageEnum.WARN, msg, title);
    }

    error(msg: string, title?: string) {
        this.addSingle(TypeMessageEnum.ERROR, msg, title);
    }

    info(msg: string, title?: string) {
        this.addSingle(TypeMessageEnum.INFO, msg, title);
    }

    private addSingle(type: TypeMessageEnum, msg: string, title?: string) {
        this.snackBarRef = this.snackBar.openFromComponent(NotificationComponent, {
            data: {
                msg: msg,
                title: title,
                type: type
            },
            duration: 4000,
            verticalPosition: 'top',
            horizontalPosition: 'end',
        });
    }

    clear() {
        //this.messageService.clear();
        this.snackBar.dismiss();
    }
}